import BrowserFetchTransport from './BrowserFetchTransport'
import { error_codes, ValidationError } from './errors'

export default class REST_Client {

	// Offset between local time and server time (Anvil.moment.duration object)
	_time_offset = Anvil.moment.duration(0)
	get time_offset () { return this._time_offset }
	set time_offset (value) {
		if (Math.abs(this._time_offset.asMilliseconds() - value.asMilliseconds()) > 30000) {
			console.warn(`REST [${this.host}:${this.port}] - significant time offset change`)
		}
		this._time_offset = value
		console.log(`REST [${this.host}:${this.port}] - time offset is now ${value.asMilliseconds()}ms`)
	}

	constructor (host, port = 443, api_key = null, options = {}) {
		this.api_key = api_key
		this.host = host
		this.port = port
		this.timeout = options.timeout || 30000
		this.transport = options.transport || new BrowserFetchTransport(host, port, this.timeout)
	}

	async get (resource, raw = false) {
		return await this.request('GET', resource, null, raw)
	}

	async post (resource, data = null, raw = false) {
		return await this.request('POST', resource, data, raw)
	}

	async put (resource, data = null, raw = false) {
		return await this.request('PUT', resource, data, raw)
	}

	async delete (resource, raw = false) {
		return await this.request('DELETE', resource, null, raw)
	}

	async request (method, resource, data = null, raw = false) {

		// Pack data object
		if (data !== null) data = JSON.stringify(data)

		// Compile request headers
		const headers = {}
		headers['Sec-Fetch-Site'] = 'cross-site'
		// Authentication header
		if (this.api_key !== null) {
			headers['Auth'] = this.api_key
		} else if (Anvil.session.access_token !== null) {
			headers['X-Access-Token'] = Anvil.session.access_token
		}
		// Add payload related headers if we are sending data
		if (method !== 'GET' && method !== 'HEAD' && data !== null) {
			headers['Content-Type'] = 'application/json'
			headers['Content-Length'] = (new TextEncoder().encode(data)).byteLength
		}

		const request_start = Anvil.moment()

		try {
			const response = await this.transport.request(method, resource, headers, data, raw)
			const response_headers = response.headers || {}
			const response_body = response.body

			// Set time-offset based on server clock
			if ('date' in response_headers) {
				const server_time = Anvil.moment(response_headers.date)
				this.time_offset = Anvil.moment.duration(request_start.diff(server_time))
			}

			// At this point, the response has arrived
			console.log(`REST [${this.host}:${this.port}] - request '${method}:${resource}' returned with statusCode: ${response.statusCode}`)

			if (response.statusCode >= 200 && response.statusCode < 300) {
				if (!raw) {
					if (response_body === '' || typeof response_body == 'undefined') return null
					return JSON.parse(response_body)
				}
				return [ response, response_body ]
			}

			switch (response.statusCode) {
				case 422:
					// Validation error
					throw new ValidationError(JSON.parse(response_body || '{}'), error_codes[response.statusCode])

				case 401:
					// Unauthorized
					Anvil.exec('auth/action_logout', true)
					throw new Error('Lejárt a munkamenet')

				case 403:
					// Forbidden
					throw new Error((response_body ? JSON.parse(response_body).message : null) || error_codes[response.statusCode])

				default:
					// Other error
					throw new Error((response.statusCode.toString() in error_codes) ? error_codes[response.statusCode] : error_codes.general)
			}

		} catch (err) {
			// Connection timeout or abort
			if ((err && err.name == 'AbortError') || ('code' in err && err.code == 'ECONNRESET'))
				throw new Error('A lekérdezés megszakadt.')

			// Connection could not be established
			if ((err && err.name == 'TypeError') || ('code' in err && err.code == 'ECONNREFUSED'))
				throw new Error('Nincs kapcsolat a kiszolgálóval, kérjük ellenőrizze az internetkapcsolatot.')

			// There was an unexpected error during the request
			throw err
		}
	}
}
